module.exports = __webpack_public_path__ + "img/jesolospiagge-platinum-beach.53d0ca0b.png";